import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input,TreeSelect } from 'antd'

import { Page,Crud } from '../../components'

const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class CertTypePage extends Component {
  static propTypes = {
    system: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
    const { getAllCertType } = this.props.actions;
     const { certTypePage,currentCertType} = this.props.system;
     getAllCertType();
     this.fetchList( certTypePage);
  }

  fetchList = (page,values) => {
    const {getCertTypeList} = this.props.actions;
    let params = Object.assign({},{page:page},values)
    getCertTypeList(params);
  }

  getDataSource() {
    const { system } = this.props;
    const { certTypeById, certTypeList } = system;
    if (!certTypeList) return [];
    return certTypeList.map(id => certTypeById[id]);
  }

  get listProps() {
    const { system,actions } = this.props
    const { getCertTypeListPending,certTypeTotal,certTypePage,allCertTypeById ,originCertTypeTree} = system
    const { deleteCertType,chooseCurrentCertType,certTypeModalChange } = actions;

    return {
      dataSource: originCertTypeTree,
      loading: getCertTypeListPending,
      columns:[
        {
          title: "名称",
          dataIndex: 'name',
          key: 'name',
          align: 'left',
          width: 180,
        },
        {
          title: "排序号",
          dataIndex: 'orderNum',
          key: 'orderNum',
          align: 'left',
          width: 180,
        },
      ],
      pagination:undefined,
      op:[
       {
          key:1,
          name:'编辑',
          buttonProps:{
            icon:"edit",
            type:"primary"
          },
        },
        {
          key:3,
          name:'删除',
          buttonProps:{
            icon:"delete",
            type:"danger"
          },
          needConfirm:true,
          confirmTitle:"确认删除"
        }
      ],
      handleMenuClick: (record,item) => {
        if (item.key == 1){
          chooseCurrentCertType(record);
          certTypeModalChange(true,"updata");
        }else if(item.key == 3){
            deleteCertType(record.id).then((data) => {
            this.fetchList(certTypePage);
          })
        }
      }
    }
  } 

  get modalProps() {
    const { system,actions } = this.props
    const { currentCertType, certTypeModalVisible,certTypePage, certTypeModalType,submitCertTypePending,certTypeTree } = system

    const { certTypeModalChange,submitCertType,getAllCertType } = actions;
    const editItem  = certTypeModalType === 'create' ? {} : currentCertType
    return {
      item: certTypeModalType === 'create' ? {} : currentCertType,
      visible: certTypeModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitCertTypePending,
      title: `${
        certTypeModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
            key: "pid",
            label: "父级",
            initialValue: editItem.pid,
            widget: TreeSelect,
            widgetProps:{
              treeData:certTypeTree,
              treeDefaultExpandAll:false,
              onChange:this.onChange,
            },
            required: false
          },
        {
          key: "name",
          label: "名称",
          initialValue: editItem.name,
          widget: Input,
          required: true
        },
        {
          key: "orderNum",
          label: "排序号",
          initialValue: editItem.orderNum,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        submitCertType(Object.assign({},data,{})).then(data=> {
          certTypeModalChange(false,"create");
          this.fetchList(certTypePage);
          getAllCertType();
        })
      },
      onCancel() {
        certTypeModalChange(false,"create");
      },
    }
  }

  get filterProps() {
    const { actions,system } = this.props
    const { currentCertType,certTypePage} = system
    const { certTypeModalChange } = actions;

    return {
      title:"",
      searchElements: [
        {
            key: "name",
            widget: Input,
            widgetProps:{
                placeholder:"请输入名称"
            },
        },
      ],
      onFilterChange: value => {
         this.fetchList(1,value)
      },
      onAdd() {
        certTypeModalChange(true,'create')
      },
    }
  }

  get buttonProps() {
    const { actions,system } = this.props
    const { currentCertType,certTypePage} = system
    const { certTypeModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ certTypeModalChange(true,'create')}
            }
        ]
    }
  }

  render() {
    return (
      <Page inner>
        {/* <CrudFilter {...this.filterProps} /> */}
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    system: state.system,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CertTypePage);


// WEBPACK FOOTER //
// ./src/features/system/CertTypePage.js